import React from 'react';

var InputTooltip = React.createClass({

  getDefaultProps(){
    return {
      helpText: "Default help text",
      icon: "fa-question-circle"
    }
  },

  propTypes: {
    helpText: React.PropTypes.string,
    icon: React.PropTypes.string
  },

  componentWillReceiveProps(nextProps){
    if (nextProps.helpText !== this.props.helpText) {
      this.forceUpdate();
    }
  },

  render: function () {
    var {icon, helpText} = this.props;

    return (
      <label className="input">
        <i className={"icon-append fa " + icon}/>
        {this.props.children}
        <b className="tooltip tooltip-top-right">
          <i className="fa fa-warning txt-color-teal"/>
          {helpText}
        </b>
      </label>
    )
  }
});

module.exports = InputTooltip;
